/**
 * Included into the footer of pages.
 */

import * as variables from './variables.js';

import './lib/AnimationEasing';

import "./lib/AnalyticsSetup"; 

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import {MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 200,
	scrollDistanceUp: 20
});

//@ts-ignore
var StickyNav = require('./component/StickyNav.js');
StickyNav.init();

// ---------------------------------------------------------------------------------------------- //
// Animations
// import animationsIntro from './component/IntroTextAnimations';
// new animationsIntro();

// import animationsSite from './component/SiteAnimations';
// animationsSite.createInstance([
// 	{
// 		observedSelector: '.masthead, .wp-block-group, .article',
// 		options: {
// 			rootMargin: '0px 0px',
// 			threshold: 0
// 		}
// 	},
// 	{
// 		observedSelector: '.richContent, .cardListing, .listItemGroup, .story, .articles',
// 		options: {
// 			rootMargin: '-100px 0px',
// 			threshold: 0
// 		}
// 	},
// 	{
// 		observedSelector: '.callToAction',
// 		options: {
// 			rootMargin: '-150px 0px',
// 			threshold: 0
// 		}
// 	}
// ]);
// ---------------------------------------------------------------------------------------------- //



// ============================================================================
// Animations -> InViewObserver.ts
// ============================================================================
import InViewObserver from './component/InViewObserver';
InViewObserver.createInstance([
	{
		observeSelector: '.masthead, .wp-block-group, .article, .richContent, .cardListing, .listItemGroup, .story, .articles, .callToAction',
		minimum: 20,
		minimumUnit: "px"
	}
]);
// ============================================================================



// Featured Content 
// --------------------------------------------------------------------------------------------------//
const featuredContentBlock = $(".featuredContent");

if(featuredContentBlock.length !== 0) {
	// On Page Load
	// --------------------------------------------------------------------------------------------------//
	// When document is ready, make first item active and hide/close others.
	$(document).on('ready', function() {
		const firstActiveItem = featuredContentBlock.find('.item');

		for (var i = 0; i < firstActiveItem.length; i++) { 
			if(i == 0) {
				const groupId = $(firstActiveItem[i]).attr('data-content-id');
				featuredContentBlock.trigger( "updateActive", {groupId} );
			} else {
				return;
			}
		}
	});
	// --------------------------------------------------------------------------------------------------//


	// Listeners
	// --------------------------------------------------------------------------------------------------//
	// If clicked on Accordion Heading
	$('.featuredContent__items .item__heading').on( "click" , function( event ) {
		const groupId = $(this).parent().attr('data-content-id');
		featuredContentBlock.trigger( "updateActive", {groupId} );
	});
	// --------------------------------------------------------------------------------------------------//


	// Triggers
	// --------------------------------------------------------------------------------------------------//
	// Updates 'Active' Content
	featuredContentBlock.on( "updateActive" , function( event, data ) {
		const updateActiveHeading = featuredContentBlock.find(".body__content");

		for (var i = 0; i < updateActiveHeading.length; i++) { 
			if(data.groupId === updateActiveHeading[i].dataset.contentId) {
				if ($(updateActiveHeading[i]).hasClass("active")) {
					$(updateActiveHeading[i]).removeClass("active").find(".body__content");
				} else {
					$(updateActiveHeading[i]).addClass("active").find(".body__content");
				}
			} else {
				$(updateActiveHeading[i]).removeClass("active").find(".body__content");
			}
		}
	});

	// Updates 'Active' Heading
	featuredContentBlock.on( "updateActive" , function( event, data ) {
		const updateActiveBuilding = featuredContentBlock.find(".item");

		for (var i = 0; i < updateActiveBuilding.length; i++) { 
			if(data.groupId === updateActiveBuilding[i].dataset.contentId) {
				if ($(updateActiveBuilding[i]).hasClass("active")) {
					$(updateActiveBuilding[i]).removeClass("active");
				} else {
					$(updateActiveBuilding[i]).addClass("active");
				}
			} else {
				$(updateActiveBuilding[i]).removeClass("active");
			}
		}
	});
}